export default __webpack_public_path__ + "static/media/arrB.7d4977ad.svg";